/* Vertical Unit — vu-theme.js (build 2026-10)
   Progressive enhancement for the vu-* sections. No jQuery, no framework. Runs after global.js (defer).
   The variant picker, cart and drawer stay the theme's own components; this file only reacts to them.
   Hooks (see theme-work/vu/CONTRACT.md §6): .vu-menu-btn/#vu-drawer, .vu-more-btn/#vu-mehr, details.vu-loc,
   .vu-variants (inside <variant-radios>), .vu-g-track[data-variant-id], .vu-g-thumbs[data-variant-id],
   #vu-v-live, #vu-atc, .vu-sticky-atc, #vu-variants (JSON), details.vu-acc, nav.vu-toc, section.vu-gsec[id]. */
(function () {
  'use strict';
  var d = document, body = d.body, root = d.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var t = (window.vuStrings || {});

  /* ---------- header: mobile menu ---------- */
  var menuBtn = d.querySelector('.vu-menu-btn');
  var drawer = d.getElementById('vu-drawer');
  function setMenu(open, restoreFocus) {
    if (!menuBtn || !drawer) return;
    menuBtn.setAttribute('aria-expanded', String(open));
    var vh = menuBtn.querySelector('.vu-vh');
    if (vh) vh.textContent = open ? (t.menuClose || 'Menü schliessen') : (t.menu || 'Menü');
    drawer.hidden = !open;
    body.classList.toggle('vu-menu-open', open);
    if (open) { var f = drawer.querySelector('a,button,summary'); if (f) f.focus(); }
    else if (restoreFocus) { menuBtn.focus(); }
    syncSticky();
  }
  if (menuBtn) menuBtn.addEventListener('click', function () {
    setMenu(menuBtn.getAttribute('aria-expanded') !== 'true', true);
  });

  /* ---------- header: "Mehr" dropdown ---------- */
  var moreBtn = d.querySelector('.vu-more-btn');
  var moreMenu = d.getElementById('vu-mehr');
  function setMore(open, restoreFocus) {
    if (!moreBtn || !moreMenu) return;
    moreBtn.setAttribute('aria-expanded', String(open));
    moreMenu.hidden = !open;
    body.classList.toggle('vu-more-open', open);
    if (!open && restoreFocus) moreBtn.focus();
    syncSticky();
  }
  if (moreBtn && moreMenu) {
    moreBtn.addEventListener('click', function () { setMore(moreBtn.getAttribute('aria-expanded') !== 'true'); });
    d.addEventListener('click', function (e) {
      if (moreBtn.getAttribute('aria-expanded') === 'true' && !e.target.closest('.vu-more')) setMore(false);
    });
    moreMenu.addEventListener('focusout', function (e) {
      if (!e.relatedTarget || !e.relatedTarget.closest('.vu-more')) setMore(false);
    });
  }

  /* ---------- header: localization disclosures (native <details>) ---------- */
  var locs = d.querySelectorAll('details.vu-loc');
  locs.forEach(function (det) {
    det.addEventListener('toggle', function () {
      if (det.open) locs.forEach(function (o) { if (o !== det) o.open = false; });
    });
  });
  d.addEventListener('click', function (e) {
    if (e.target.closest('details.vu-loc')) return;
    locs.forEach(function (o) { o.open = false; });
  });

  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (moreBtn && moreBtn.getAttribute('aria-expanded') === 'true') setMore(false, true);
    if (menuBtn && menuBtn.getAttribute('aria-expanded') === 'true') setMenu(false, true);
    locs.forEach(function (o) { if (o.open) { o.open = false; var s = o.querySelector('summary'); if (s) s.focus(); } });
  });
  window.addEventListener('resize', function () {
    if (window.innerWidth >= 990 && menuBtn && menuBtn.getAttribute('aria-expanded') === 'true') setMenu(false);
  });

  /* header height → --vu-header-h (sticky offsets, scroll-margin) */
  var hdr = d.querySelector('.vu-site-header');
  if (hdr && 'ResizeObserver' in window) {
    new ResizeObserver(function () { root.style.setProperty('--vu-header-h', hdr.offsetHeight + 'px'); }).observe(hdr);
  }

  /* ---------- product: variant data, cards, gallery ---------- */
  var dataEl = d.getElementById('vu-variants');
  // Refresh's VariantSelects.filterThumbnail (global.js L789) runs jQuery + console.log on every change for thumbnails that
  // do not exist on this template; neutralise it on the vu product page only (plan §4.1). The class is a top-level script binding.
  if (d.querySelector('.vu-pdp') && typeof VariantSelects !== 'undefined' && VariantSelects.prototype) {
    VariantSelects.prototype.filterThumbnail = function () {};
  }
  var DATA = null;
  if (dataEl) { try { DATA = JSON.parse(dataEl.textContent); } catch (err) { DATA = null; } }
  var tracks = d.querySelectorAll('.vu-g-track[data-variant-id]');
  var thumbsets = d.querySelectorAll('.vu-g-thumbs[data-variant-id]');
  var live = d.getElementById('vu-v-live');
  var currentVariant = null;

  function activeTrack() { return d.querySelector('.vu-g-track[data-variant-id]:not([hidden])'); }
  function activeThumbs() { return d.querySelector('.vu-g-thumbs[data-variant-id]:not([hidden])'); }
  function currentIndex(track) {
    return track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0;
  }
  function markThumb(i) {
    var th = activeThumbs(); if (!th) return;
    th.querySelectorAll('button').forEach(function (b) {
      if (+b.dataset.i === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
    });
    var tr = activeTrack();
    var counter = tr && tr.closest('.vu-gallery') && tr.closest('.vu-gallery').querySelector('[data-vu-counter]');
    if (counter) counter.textContent = (i + 1) + ' / ' + tr.children.length;
  }
  d.addEventListener('click', function (e) {
    var b = e.target.closest('.vu-g-thumbs button'); if (!b) return;
    var tr = activeTrack(); if (!tr) return;
    var i = +b.dataset.i;
    tr.scrollTo({ left: i * tr.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    markThumb(i);
  });
  tracks.forEach(function (tr) {
    var tm;
    tr.addEventListener('scroll', function () { clearTimeout(tm); tm = setTimeout(function () { if (!tr.hidden) { markThumb(currentIndex(tr)); var i = currentIndex(tr); tr.querySelectorAll('.vu-g-video video').forEach(function (v) { var li = v.closest('li'); if (Array.prototype.indexOf.call(tr.children, li) !== i) v.pause(); }); } }, 80); });
  });

  function showGallery(variantId) {
    d.querySelectorAll('.vu-g-video video').forEach(function (v) { v.pause(); });
    var any = false;
    tracks.forEach(function (tr) { var on = tr.dataset.variantId === String(variantId); tr.hidden = !on; if (on) { any = true; tr.scrollLeft = 0; } });
    thumbsets.forEach(function (th) { th.hidden = th.dataset.variantId !== String(variantId); });
    if (!any && tracks[0]) { tracks[0].hidden = false; if (thumbsets[0]) thumbsets[0].hidden = false; }
    var tr = activeTrack();
    if (tr && !reduce) {
      tr.classList.add('vu-switching');
      setTimeout(function () { tr.classList.remove('vu-switching'); }, 220);
    }
    markThumb(0);
  }

  function applyVariant(variantId, announce) {
    if (!DATA || !DATA[variantId]) return;
    var v = DATA[variantId];
    currentVariant = variantId;
    d.querySelectorAll('.vu-v-card').forEach(function (c) {
      var inp = c.querySelector('input');
      var on = inp && inp.value === v.option1;
      c.classList.toggle('is-checked', !!on);
    });
    d.querySelectorAll('[data-v-label]').forEach(function (el) { el.textContent = v.label; });
    d.querySelectorAll('[data-v-price]').forEach(function (el) { el.innerHTML = v.price_html; });
    showGallery(variantId);
    var st = d.querySelector('.vu-sticky-atc button');
    if (st) { st.disabled = !v.available; }
    if (announce && live) {
      live.textContent = (t.chosen || 'Gewählt') + ': ' + v.label + (v.cat ? ', ' + v.cat : '') + (v.vlt ? ', VLT ' + v.vlt : '') + (v.use ? ', ' + v.use : '') + '. ' + (t.imagesShow || 'Bilder zeigen jetzt') + ' ' + v.label + '.';
    }
  }
  function variantIdFromOption(value) {
    if (!DATA) return null;
    for (var k in DATA) if (DATA[k].option1 === value) return k;
    return null;
  }
  // the theme's <variant-radios> owns the inputs; we react to the same change event
  d.addEventListener('change', function (e) {
    var inp = e.target;
    if (!inp.matches || !inp.matches('.vu-variants input[type="radio"]')) return;
    var id = variantIdFromOption(inp.value);
    if (id) applyVariant(id, true);
  });
  if (DATA) {
    var checked = d.querySelector('.vu-variants input[type="radio"]:checked');
    var startId = checked ? variantIdFromOption(checked.value) : null;
    if (!startId) { for (var first in DATA) { startId = first; break; } }
    applyVariant(startId, false);
    // prefetch the other colours' first image after load (plan §3.1 #4)
    window.addEventListener('load', function () {
      setTimeout(function () {
        for (var k in DATA) {
          if (k === currentVariant) continue;
          var img = DATA[k].images && DATA[k].images[0];
          if (!img || !img.src) continue;
          var l = d.createElement('link'); l.rel = 'prefetch'; l.as = 'image'; l.href = img.src; d.head.appendChild(l);
        }
      }, 1500);
    });
  }

  /* Explicit, keyboard/touch accessible image detail. */
  var lb = d.getElementById('vu-lightbox');
  var zoomOrigin;
  if (lb && typeof lb.showModal === 'function') {
    d.addEventListener('click', function (e) {
      var control = e.target.closest('[data-vu-zoom]');
      var img = e.target.closest('.vu-g-slide img');
      if (!control && (!img || window.innerWidth < 990)) return;
      zoomOrigin = control || img;
      var target = lb.querySelector('img');
      target.src = control ? control.dataset.vuZoom : (img.dataset.full || img.currentSrc || img.src);
      target.alt = control ? (control.dataset.vuAlt || control.getAttribute('aria-label') || '') : img.alt;
      target.style.transform = control && (control.dataset.vuAngle === '2deg' || control.dataset.vuAngle === '2') ? 'rotate(2deg)' : 'none';
      if (!lb.open) lb.showModal();
    });
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.closest('[data-vu-close]')) lb.close(); });
    lb.addEventListener('close', function () { if (zoomOrigin && zoomOrigin.focus) zoomOrigin.focus(); });
  }

  /* ---------- sticky add-to-cart (below 990px, only while the main button is off-screen) ---------- */
  var sticky = d.querySelector('.vu-sticky-atc');
  var mainBtn = d.getElementById('vu-atc');
  var btnVisible = true;
  function syncSticky() {
    if (!sticky) return;
    var menuOpen = body.classList.contains('vu-menu-open') || body.classList.contains('vu-more-open');
    var show = mainBtn && mainBtn.getBoundingClientRect().bottom < 0 && !menuOpen && window.innerWidth < 990;
    sticky.hidden = !show;
    root.style.setProperty('--vu-sticky-h', show ? sticky.offsetHeight + 'px' : '0px');
  }
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) { btnVisible = entries[0].isIntersecting; syncSticky(); }, { threshold: 0 }).observe(mainBtn);
    window.addEventListener('resize', syncSticky);
  }

  /* ---------- a link into a closed accordion opens it ---------- */
  function openTarget(hash) {
    if (!hash || hash.length < 2) return null;
    var el; try { el = d.querySelector(hash); } catch (err) { return null; }
    if (!el) return null;
    var det = el.tagName === 'DETAILS' ? el : el.closest('details');
    if (det) det.open = true;
    return el;
  }
  d.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="#"]'); if (!a) return;
    var u; try { u = new URL(a.href, location.href); } catch (err) { return; }
    if (u.pathname === location.pathname && u.hash) openTarget(u.hash);
  });
  window.addEventListener('hashchange', function () { openTarget(location.hash); });
  if (location.hash) { var target = openTarget(location.hash); if (target) target.scrollIntoView(); }

  /* ---------- fit guide: TOC aria-current ---------- */
  var toc = d.querySelector('nav.vu-toc');
  var secs = d.querySelectorAll('section.vu-gsec[id]');
  if (toc && secs.length && 'IntersectionObserver' in window) {
    var links = {};
    toc.querySelectorAll('a[href^="#"]').forEach(function (a) { links[a.getAttribute('href').slice(1)] = a; });
    var visible = {};
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { visible[en.target.id] = en.isIntersecting ? en.boundingClientRect.top : null; });
      var best = null;
      secs.forEach(function (s) { if (visible[s.id] !== null && visible[s.id] !== undefined && (best === null || visible[s.id] < visible[best])) best = s.id; });
      if (!best) return;
      Object.keys(links).forEach(function (id) { if (id === best) links[id].setAttribute('aria-current', 'true'); else links[id].removeAttribute('aria-current'); });
    }, { rootMargin: '-20% 0px -60% 0px', threshold: 0 }).observe && secs.forEach(function (s) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            Object.keys(links).forEach(function (id) { if (id === en.target.id) links[id].setAttribute('aria-current', 'true'); else links[id].removeAttribute('aria-current'); });
          }
        });
      }, { rootMargin: '-20% 0px -65% 0px', threshold: 0 }).observe(s);
    });
  }

  /* ---------- reveal-once (home only; never the hero) ---------- */
  if (!reduce && body.classList.contains('vu-t-home') && 'IntersectionObserver' in window) {
    var rv = d.querySelectorAll('[data-vu-reveal]');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('vu-revealed'); io.unobserve(en.target); } });
    }, { threshold: 0.15 });
    rv.forEach(function (el) { io.observe(el); });
  }
  /* Optional fit checklist, preserves the source list without JavaScript. */
  var checklist = d.querySelector('#vu-checkliste .vu-tick');
  if (checklist) {
    var checks = [];
    checklist.querySelectorAll('li').forEach(function (li) {
      var label = d.createElement('label'), input = d.createElement('input'), text = d.createElement('span');
      input.type = 'checkbox';
      while (li.firstChild) text.appendChild(li.firstChild);
      label.appendChild(input); label.appendChild(text); li.appendChild(label); checks.push(input);
    });
    var progress = d.createElement('p'); progress.className = 'vu-check-progress'; progress.setAttribute('role','status');
    checklist.after(progress);
    function updateChecks() { progress.textContent = (d.getElementById('vu-guide').dataset.checklistLabel || '') + ' ' + checks.filter(function (x) {return x.checked;}).length + ' / ' + checks.length; }
    checks.forEach(function (input) { input.addEventListener('change',updateChecks); }); updateChecks();
  }
})();
